import {
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  ModalProps,
  Text,
  VStack,
} from "@chakra-ui/react";

export type SimplePopupProps = ModalProps & {
  title?: string;
  description?: string;
  isClosable?: boolean;
  hasScrollArea?: boolean;
};

const SimplePopup = ({
  title,
  description,
  size,
  isClosable = true,
  hasScrollArea = false,
  children,
  ...rest
}: SimplePopupProps) => {
  return (
    <Modal closeOnEsc={isClosable} closeOnOverlayClick={isClosable} {...rest}>
      <ModalOverlay />
      <ModalContent
        w={size}
        maxH={hasScrollArea ? "calc(100vh - 2rem)" : ""}
        my={hasScrollArea ? "0" : "6"}
      >
        {isClosable && <ModalCloseButton mt="1" />}

        <ModalBody
          pt="2"
          pb="6"
          px="4"
          display="flex"
          flexDir="column"
          maxH="full"
        >
          {(title || description) && (
            <VStack w="full" spacing="1" textAlign="center">
              {title && (
                <Heading
                  fontSize="2xl"
                  lineHeight="1.3"
                  fontWeight="bold"
                  maxW="18rem"
                  pt="6"
                >
                  {title}
                </Heading>
              )}

              {description && (
                <Text fontSize="sm" opacity="0.8" maxW="18rem">
                  {description}
                </Text>
              )}
            </VStack>
          )}

          {children}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default SimplePopup;
